<template>
  <div class="first-last-step">
    <loading :active.sync="isLoading" color="#4CAF50" :width=100 :height=100 :opacity=.7></loading>
    <div v-if="resources" class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="first-last-step__welcome">Рады видеть,</div>
                <div class="first-last-step__name">{{resources.agent.fullname}}</div>
            </div>
            <div class="col-md-12">
              <div v-for="route in resources.routes" :key="route.routeId">
                <Route :route="route" />
              </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $backend from '../backend'
import Loading from 'vue-loading-overlay'
import Route from '@/components/Route.vue'

export default {
  name: 'firstStep',
  data () {
    return {
      isLoading: false,
      resources: null
    }
  },
  created () {
    this.fetchRoute()
  },
  components: {
    Loading,
    Route
  },
  methods: {
    fetchRoute () {
      this.isLoading = true
      $backend.fetchData('route')
        .then(responseData => {
          this.resources = responseData
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
